export default __webpack_public_path__ + "static/media/garage-down.0cb5ddc0.gif";